import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMoonOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.165 7.874a4.333 4.333 0 0 1-6.04-6.04H8a6.167 6.167 0 1 0 6.165 6.04"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMoonOutlined);
export default ForwardRef;
